export function getOffPlatformBookingPendingUrl(shipmentId: number): string {
  return `/shipments/${shipmentId}/off-platform-bookings/pending`;
}
